<template>
  <router-view />
</template>

<script>
// import { load_script } from '@/_helpers/utils.js';

/* что то делаем сразу после авторизации, но до рендера основого приложения */
export default {
  name: 'RoutesInnerWrapper'

  // mounted() {
  //   load_script(
  //     'https://my.hellobar.com/bd2d8d1f9104806aa0aaea43b642df2cf2b6bc7f.js',
  //     'hellobar',
  //     () => {}
  //   );
  // }
};
</script>
